import { render, staticRenderFns } from "./stockPackageList.vue?vue&type=template&id=95c606da"
import script from "./stockPackageList.vue?vue&type=script&lang=js"
export * from "./stockPackageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports